module.exports = __webpack_public_path__ + "static/media/4.464b6bea.png";